import queryString from "query-string";

require('dotenv');
const axios = require('axios').default;

export const Api = {
    async getAll() {
        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint;
        const response = await axios.get(URL, { withCredentials: true });
        return response;
    },

    async getFiltered(filter) {

        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint + "filter/";
        const response = await axios.post(URL, filter, { withCredentials: true });
        return response;
    },

    async get(id) {
        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint + id;
        const response = await axios.get(URL, { withCredentials: true });
        return response;
    },

    async add(item) {
        delete item.id;

        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint;
        const response = await axios.post(URL, item, { withCredentials: true });
        return response;
    },

    async update(item, includeId) {
        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint + item.id;

        const response = await axios.put(URL, item, { withCredentials: true });
        return response;
    },

    async delete(id) {
        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint + id;

        const response = await axios.delete(URL, { withCredentials: true });
        return response;
    }
}